import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { CustomThemeProvider } from "./contexts/CustomThemeContext";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ThemedChakraProvider from "./components/Theme/ThemedChakraProvider";
import { API_BASE_URL, IS_PRODUCTION } from "./configs/api";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

console.log("PickDengu frontend environment:", {
  nodeEnv: process.env.NODE_ENV,
  appEnv: process.env.REACT_APP_ENV,
  apiBaseUrl: API_BASE_URL,
  isProduction: IS_PRODUCTION,
});

root.render(
  <React.StrictMode>
    <AuthProvider>
      <CustomThemeProvider>
        <ThemedChakraProvider>
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </ThemedChakraProvider>
      </CustomThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
